<template>
  <div class="detail YTemplate" >
    <div class="YTitle">日常巡检详情</div>
    <div class="main" v-if="detailData">
      <div class="row"><span class="label">巡检标题：</span><span class="boxshadow">{{detailData.title}}</span></div>
      <div class="row"><span class="label">巡检描述：</span><span class="boxshadow">{{detailData.description}}</span></div>
      <div class="row"><span class="label">违规处理：</span><span class="boxshadow">{{detailData.handling.name}}</span></div>
      <div class="row"><span class="label">巡检项：</span><span class="boxshadow">{{detailData.inspectionItem.name}}</span></div>
      <div class="row" v-if="detailData.penalty && detailData.penalty != 0"><span class="label">罚款金额：</span><span class="boxshadow">{{detailData.penalty}}</span></div>
      <div class="row"><span class="label">商户名称：</span><span class="boxshadow">{{detailData.shopName}}</span></div>
      <div class="row"><span class="label">申诉状态：</span><span class="boxshadow">{{detailData.appealStatus.name}}</span></div>
      <div class="row" v-if="detailData.comment.length !== 0"><span class="label">申诉留言：</span> </div>
      <el-timeline>
        <el-timeline-item v-for="item in detailData.comment" :key="item.id" :timestamp="item.createTime" type="success" color="#409EFF" size="large" placement="top">
          <el-card>
            <h3 class="title">{{item.commentUser}}</h3>
            <p>{{item.comment}}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <div class="row" v-if="detailData.appealStatus.type !== 2"><span class="label">申诉留言：</span> <el-input type="textarea" class="boxshadow" :rows="3" v-model.trim="words" placeholder="请输入申诉留言"></el-input></div>
      <div class="row" v-if="imgArrs.length !== 0"><span class="label">图片：</span>
        <el-image
        style="width: 1rem; height: 1rem"
        v-for="(src, index) of imgArrs"
        :key="index"
        :src="src"
        fit="contain"></el-image>
      </div>
    </div>
    <div class="btn">
      <el-button round type="warning" v-if="detailData && detailData.appealStatus.type !== 2 && detailData.appealStatus.type !== 4 && jurisdiction.includes('1890')" @click="submitAppealDetail">申诉</el-button>
      <el-button round type="success" v-if="detailData && detailData.appealStatus.type !== 0 && detailData.appealStatus.type !== 2 && jurisdiction.includes('APPEAL_INSPECTION_EDIT')" @click="auditing(0)">审核通过</el-button>
      <el-button round type="danger" v-if="detailData && detailData.appealStatus.type !== 0 && detailData.appealStatus.type !== 2 && jurisdiction.includes('APPEAL_INSPECTION_EDIT')" @click="auditing(1)">审核不通过</el-button>
      <el-button round type="success" v-if="detailData && detailData.appealStatus.type !== 2 && detailData.appealStatus.type !== 4 && jurisdiction.includes('INSPECTION_AGREE')" @click="confirmInsp">确认巡检</el-button>
      <el-button round type="primary" @click="close">返回</el-button>
    </div>
  </div>
</template>
<script>
import api from '@/shared/api/apps/inspection'
import { mapState } from 'vuex'
export default {
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['jurisdiction'])
  },
  data () {
    return {
      detailData: '',
      imgArrs: [],
      words: ''
    }
  },
  watch: {
    data: {
      immediate: true,
      handler (id) {
        this.getData(id)
      }
    }
  },
  methods: {
    getData (id) {
      const params = {
        method: api.lookDaily,
        id
      }
      this.axios.post(params).then(res => {
        if (res.data.backend_odc_daytodayinspection_get_response.code !== '10000') return
        this.detailData = res.data.backend_odc_daytodayinspection_get_response.result
        if (this.detailData.image !== '') {
          this.imgArrs = this.detailData.image.split(',')
        }
      }).catch(e => {})
    },
    close () {
      this.$emit('hiddenDetail')
    },
    // 申诉
    submitAppealDetail () {
      if (!this.words) {
        this.$message.error('请输入申诉留言')
        return
      }
      const params = {
        method: api.getAppealDetail,
        inspectionClass: 0,
        comment: this.words,
        pid: this.detailData.id
      }
      this.axios.post(params).then(res => {
        if (res.data.backend_odc_inspectionappeal_add_response.code !== '10000') return
        this.$message.success('提交申诉成功')
        this.$emit('hiddenDetail')
      })
    },
    // 确认巡检
    confirmInsp () {
      const params = {
        method: api.confirmInspection,
        inspectionClass: 0,
        pid: this.detailData.id
      }
      this.axios.post(params).then(res => {
        if (res.data.backend_odc_inspectionappeal_agree_response.code !== '10000') return
        this.$message.success('确认巡检成功')
        this.$emit('hiddenDetail')
      })
    },
    // 审核
    auditing (type) {
      if (!this.words) {
        this.$message.error('请输入申诉留言')
        return
      }
      const params = {
        method: api.auditing,
        inspectionClass: 0,
        comment: this.words,
        pid: this.detailData.id,
        appealResult: type
      }
      this.axios.post(params).then(res => {
        if (res.data.backend_odc_inspectionappeal_edit_response.code !== '10000') return
        this.$message.success('审核状态已修改')
        this.$emit('hiddenDetail')
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .detail
    display flex
    flex-direction column
    overflow-y scroll
    overflow-x hidden
    .main
      flex auto
      margin 20px
      margin-left 60px
  .btn
    text-align center
    margin 60px 0
  .row
    display flex
    align-items center
    margin-bottom 30px
    .label
      width 120px
      text-align right
    .el-textarea
      width 60%
  .boxshadow
    padding 6px 100px 6px 10px
  .el-timeline
    margin-left .6rem
    .title
      font-weight bold
</style>
